var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-box"},[_c('el-form',{attrs:{"model":_vm.formData,"label-width":"70px"}},[_c('FormItemComp',{attrs:{"formState":_vm.root}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }